(function () {

  'use strict';

  function pxGroupSyncPickerForm($http, $rootScope, $filter, $log, toastr) {
    return {
      restrict: 'E',
      scope: {
        context: '=',
        resource: '=',
        meta: '=',
        callback: '&'
      },
      templateUrl: 'app/components/groupList/_groupSyncPickerForm/groupSyncPickerForm.template.html',
      link: function (scope) {

        scope.model = { selected: null };
        scope.submitting = false;
        scope.selectDataObject = null;

        (function buildSelectOptions() {
          const directories = (scope.resource && scope.resource.directories) || [];
          if (!directories.length) {
            return;
          }
          scope.selectDataObject = {
            listRaw: directories.map(function (directory) {
              return {
                id: directory.info.idp_tenant_identifier,
                name: directory.name,
                svg: directory.logoTemplate
              };
            }),
            placeholderText: 'SelectDirectory',
            skipOrderByName: true,
            svgIcon: 'yes',
            iconTileSize: 'compact'
          };
        })();

        scope.selectDirectory = function (item) {
          if (!item) {
            scope.model.selected = null;
            return;
          }
          const directories = (scope.resource && scope.resource.directories) || [];
          scope.model.selected = directories.find(function (directory) {
            return directory.info.idp_tenant_identifier === item.id;
          }) || null;
        };

        scope.synchronize = function () {
          if (!scope.model.selected) {
            return;
          }
          const syncLink = scope.resource &&
            scope.resource.tenant &&
            scope.resource.tenant.info &&
            scope.resource.tenant.info._links &&
            scope.resource.tenant.info._links['px:groupSynchronization'];
          if (!syncLink || !syncLink.href) {
            toastr.error($filter('translate')('ERROR'));
            scope.callback();
            return;
          }
          scope.submitting = true;
          const separator = syncLink.href.indexOf('?') >= 0 ? '&' : '?';
          const url = syncLink.href + separator + 'directory=' + encodeURIComponent(scope.model.selected.info.idp_tenant_identifier);
          $http.post(url).then(function (response) {
            toastr.success($filter('translate')('GroupsSynchronizationStarted'));
            $rootScope.synchronizingGroupsIsOngoing = true;
            $rootScope.synchronizingGroupsIsOngoingSubTaskIds = response.data.subTasks;
            scope.callback();
          }).catch(function (error) {
            $log.error('groupSyncPickerForm.synchronize failed', error);
            toastr.error($filter('translate')('ERROR'));
            scope.submitting = false;
          });
        };

      }
    };
  }

  pxGroupSyncPickerForm.$inject = ['$http', '$rootScope', '$filter', '$log', 'toastr'];

  angular
    .module('printix-admin')
    .directive('pxGroupSyncPickerForm', pxGroupSyncPickerForm);

})();
